"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addSuffix = void 0;
var addSuffix = function addSuffix(val, suffix) {
  return typeof val !== 'undefined' && suffix ? "" + val + suffix : val;
};
exports.addSuffix = addSuffix;